import { User } from '../contexts/UserContext'

export default (customer: User) => {
  const { socialReason, lastname, firstname } = customer
  const name =
    lastname && firstname ? `${lastname} ${firstname}` : customer.contact
  return [socialReason, name].filter(x => x).join(' - ')
}
